import { CSSProperties } from "react";

const EqualIcon = (props?: { color?: string; style?: CSSProperties }) => {
  let c = "#24AF22";
  if (props && props.color) c = props.color;
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={(props && props.style) || {}}
    >
      <rect width="32" height="32" rx="2" fill="white" />
      <path
        d="M6.40313 12.4996H25.7075C26.6776 12.4996 27.4624 11.7165 27.4624 10.7496C27.4624 9.78273 26.6776 9.04883 25.7075 9.04883H6.40313C5.43298 9.04883 4.64819 9.83141 4.64819 10.7496C4.64819 11.6678 5.43298 12.4996 6.40313 12.4996ZM25.7075 19.4996H6.40313C5.43298 19.4996 4.64819 20.2822 4.64819 21.2004C4.64819 22.1186 5.43298 22.9504 6.40313 22.9504H25.7075C26.6776 22.9504 27.4624 22.1673 27.4624 21.2004C27.4624 20.2335 26.6782 19.4996 25.7075 19.4996Z"
        fill={c}
      />
    </svg>
  );
};

export default EqualIcon;
